<div class="login-bg bg-img">
  <div class="container">
    <div class="row loginOuterWrap">
      <div class="col-md-6 col-md-offset-4 login-mid">

        <div class="login-header ui-g-12">
          <div class="tiger-logo animated fadeIn">
          </div>
          <h1>Activate Account</h1>
          @if (haveCode) {
            <span>To activate your account, please enter the following and click submit.</span>
          }
        </div>

        <div class="login-inner ui-g-12">

          @if (haveCode) {
            <div>
              <form>
                <div class="login-inputWrap form-group">
                  <input class="form-control" type="password" name="txtPwd" id="txtPwd" (blur)="validateForm('pwd');" [formControl]="activateForm.controls['pwd'] | formControl" placeholder="Password" autofocus>
                  <span class="icon">
                    <i class="fal fa-lock-alt"></i>
                  </span>
                </div>
                <div class="login-inputWrap form-group">
                  <input class="form-control" type="password" name="txtConfirmPwd" id="txtConfirmPwd" (blur)="validateForm('confirmPwd');" [formControl]="activateForm.controls['confirmPwd'] | formControl" placeholder="Confirm Password">
                  <span class="icon">
                    <i class="fal fa-lock-alt"></i>
                  </span>
                </div>
                <div>
                  <div>
                    <ul>
                      @for (e of errorsList; track e) {
                        <li>{{e.Msg}}</li>
                      }
                    </ul>
                  </div>
                  <button id="btnSubmit" class="btn btn-primary" type="submit" [disabled]="!formValid" (click)="submitActivate();">Submit</button>
                  <div>{{pageMsg}}  </div>
                </div>
              </form>
            </div>
          }

          @if (!haveCode) {
            <div>
              <span>{{pageMsg}}</span>
            </div>
          }

        </div>
      </div>
    </div>
  </div>
</div>
